// Turns a route path like "/campaigns/edit-flow" into "Campaigns / Edit Flow".
// Reconstructed: the original file was never committed (import added in 3b84c8cee).
export default function pathToTitle(path) {
  return (path || '')
    .split('/')
    .filter(Boolean)
    .map((segment) =>
      segment
        .split(/[-_]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    )
    .join(' / ')
}
